<template>
  <div style="width: 40%">
            <div class="text-right">
                <Button type="primary" size="mini" @click="saveSac">{{$t('PROFILE_SAVE')}}</Button>
            </div>
        <div class="mt-10 table-with-add">
            <div class="add-block" @click="addNewRow">{{$t('TRANSPORTER_PROFILE_ADD_HSN_SAC')}}</div>
            <div>
            <Table
                :data="sacDetails"
                class="table-striped bordered mt-10"
                aria-describedby="hsnSacDetailsData"
                >
                <table-column
                :label="$t('TRANSPORTER_PROFILE_HSN_SAC_NAME')"
                width="200">
                <template slot-scope="scope">
                    <span>
                        <Input
                        class="input-blank italic-font w-100 p-0"
                        :placeholder="$t('TRANSPORTER_PROFILE_ENTER_NAME')"
                        v-model="scope.row.name"
                        size="mini"
                        :disabled="!editRow[scope.row._id] || isDataSaving"
                        type="text"/>
                    </span>
                </template>
                </table-column>
                <table-column
                :label="$t('TRANSPORTER_PROFILE_HSN_SAC_CODE')">
                <template slot-scope="scope">
                    <span>
                    <Input
                        class="input-blank italic-font w-100 p-0"
                        :placeholder="$t('TRANSPORTER_PROFILE_ENTER_CODE')"
                        v-model="scope.row.code"
                        size="mini"
                        :disabled="!editRow[scope.row._id] || isDataSaving"
                        type="text"/>
                    </span>
                </template>
                </table-column>
                 <table-column width="30">
                    <template slot-scope="scope">
                        <Tooltip :open-delay="100" effect="dark" placement="bottom" v-if="!editRow[scope.row._id]">
                        <i class="action-row" @click="editRow[scope.row._id] = true">
                            <svgicon name="icon-edit-md" width="14" height="14" :original="true"/>
                        </i>
                        <div slot="content">{{$t('EDIT')}}</div>
                        </Tooltip>
                    </template>
                </table-column>
                <table-column width="30">
                    <template slot-scope="scope">
                        <Tooltip :open-delay="100" effect="dark" placement="bottom">
                        <i class="action-row" @click="removeEntry(scope.$index, scope.row._id)">
                            <svgicon name="icon-delete-md" width="14" height="14" :original="true"/>
                        </i>
                        <div slot="content">{{$t('TRANSPORTER_PROFILE_DELETE')}}</div>
                        </Tooltip>
                    </template>
                </table-column>
            </Table>
            </div>
        </div>
        </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'HsnSac',
  data() {
    return {
      sacDetails: [],
      isDataSaving: false,
      newRowAdded: false,
      editRow: {},
      newEntries: [],
    };
  },
  // Placing watch due to design/implementation restriction
  watch: {
    isBootstrapReLoading() {
      this.resetFlags();
      this.initializeData();
    },
  },
  computed: {
    ...mapGetters({
      currentTransporter: 'app/currentTransporter',
    }),
    ...mapState('app', ['isBootstrapReLoading']),
  },
  created() {
    this.initializeData();
  },
  methods: {
    /**
     * Handler to set intial data onload
     */
    initializeData() {
      if (this.currentTransporter.hsn_sac) {
        this.sacDetails = [...this.currentTransporter.hsn_sac];
        this.editRow = this.sacDetails.reduce((acc, sac) => {
          acc[sac._id] = false;
          return acc;
        }, {});
      }
    },
    /**
     * Handler to remove specific row entry
     */
    removeEntry(position, id) {
      const isNewEntryIndex = this.newEntries.indexOf(id);
      if (isNewEntryIndex > -1) {
        this.newEntries.splice(isNewEntryIndex, 1);
        this.newRowAdded = false;
      }
      this.sacDetails.splice(position, 1);
    },
    /**
     * Handler to add a new table row
     */
    addNewRow() {
      if (!this.newRowAdded) {
        const id = Math.floor((Math.random() * 100) + 1);
        const newSac = {
          _id: id,
          name: '',
          code: '',
        };
        this.newEntries.push(id);
        this.sacDetails.unshift(newSac);
        this.editRow[id] = true;
        this.newRowAdded = true;
      }
    },
    /**
     * Handler to save details
     */
    async saveSac() {
      try {
        this.isDataSaving = true;
        const hasDuplicate = this.checkSacDuplicate(this.sacDetails);
        if (hasDuplicate) {
          this.$errorMessage({ message: this.$getErr('DUPLICATE_HSN_SAC') });
          this.isDataSaving = true;
          return false;
        }
        const validation = this.validate(this.sacDetails);
        if (validation && validation.error) {
          this.$errorMessage({ message: validation.error });
          this.isDataSaving = true;
          return false;
        }
        const data = this.sacDetails.map((_sac) => {
          if (this.newEntries.includes(_sac._id)) {
            return { code: _sac.code, name: _sac.name };
          }
          return _sac;
        });
        const result = await this.$store.dispatch('app/addHsnSac', { transporterId: this.currentTransporter.id, data });
        if (result && result.data === 'Success') {
          this.$successMessage({ message: this.$getSuccess('HSN_SAC_UPDATED') });
          await this.$store.dispatch('app/bootstrap', true);
          this.isDataSaving = false;
          return true;
        }
        const message = (result && result.error) ? result.error : this.$getErr('500');
        this.$errorMessage({ message });
        this.isDataSaving = false;
        return false;
      } catch (error) {
        this.$errorMessage({ message: this.$getErr('500') });
        this.isDataSaving = false;
        return false;
      }
    },
    /**
     * Helper handler to check for duplicates
     */
    checkSacDuplicate(data) {
      const sacItems = data;
      const namesList = sacItems.map(entry => entry.name);
      const codes = sacItems.map(entry => entry.code);
      const isDuplicateNamePresent = namesList.some(value => namesList.indexOf(value) !== namesList.lastIndexOf(value));
      const isDuplicateCodePresent = codes.some(value => codes.indexOf(value) !== codes.lastIndexOf(value));
      return isDuplicateNamePresent || isDuplicateCodePresent;
    },
    /**
     * Handler to reset data variables
     */
    resetFlags() {
      this.sacDetails = [];
      this.editRow = {};
      this.newEntries = [];
      this.newRowAdded = false;
    },
    /**
     * Handler to perform frontend validation
     */
    validate(data) {
      const sacItems = data;
      let error;
      let properInput = true;
      for (let sacIndex = 0; sacIndex < sacItems; sacIndex += 1) {
        const sacEntry = sacItems[sacIndex];
        if (sacEntry.name === '') {
          error = this.$getErr('NAME_EMPTY_ERROR');
          properInput = false;
          break;
        } else if (sacEntry.code === '') {
          error = this.$getErr('CODE_EMPTY_ERROR');
          properInput = false;
          break;
        } else if (!sacEntry.code.match(/^[a-z0-9A-Z]+$/)) {
          error = this.$getErr('IMPROPER_CODE_ERROR');
          properInput = false;
          break;
        }
      }
      if (properInput) { return null; }
      return { error };
    },
  },
};
</script>
